import _ from 'underscore';
import { wrappedOdata as odata } from './odata-wrapper';

export const BookingService = () => {
  const service = {};
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const oDataOption = {
    contentType: 'application/json',
  };

  service.createBooking = ({
    smartPageId,
    customerEmailAddress,
    manageAppointmentLink,
    bookingDetails,
    businessName,
    customerTimeZoneOffset,
    userLocale,
  }) => {
    const body = {
      SmartPageId: smartPageId,
      SPEmailAddress: customerEmailAddress,
      ManageAppointmentLink: manageAppointmentLink,
      BookingDetails: bookingDetails,
      BusinessName: businessName,
      SPTimeZoneOffset: customerTimeZoneOffset,
      UserLocale: userLocale,
    };
    const options = _.extend(
      {},
      oDataOption,
      {
        url: `${baseUrl}/newbooking`,
        data: body,
        dataType: 'text',
      }
    );

    return odata.post(options);
  };

  service.getExistingBookings = ({
    smartPageId,
  }) => {
    const body = {
      SmartPageId: smartPageId,
    };
    const options = _.extend(
      {},
      oDataOption,
      {
        url: `${baseUrl}/existingbookings`,
        data: body,
      }
    );

    return odata.post(options);
  };

  return service;
};
